import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
    selector: 'edl-modal-notes',
    templateUrl: './edl-modal-notes.component.html'
})
export class EdllModalNotesComponent {
    @Input() typeOfNote: number;
    @Input() typeId: string;
    @Input() notesToInclude: number;
    @Input() isReadOnly: boolean = false;

    constructor(
        public activeModal: NgbActiveModal,
    ) {}
}